import { render, staticRenderFns } from "./HomeKyc.vue?vue&type=template&id=74e94be8&"
import script from "./HomeKyc.vue?vue&type=script&lang=js&"
export * from "./HomeKyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports